import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { Upload } from 'antd';
import { RcFile } from 'antd/lib/upload';
import ImageKit from 'imagekit-javascript';
import { useState } from 'react';
import styles from './imagekitdirectupload.module.css';

type ImageKitDirectUploadProps = {
  value?: string,
  onChange?: (url?: string | null) => void
}

const imagekit = new ImageKit({
  publicKey: 'public_hvdUb3Gq1v1EMz7N8xZL4hasLzo=',
  urlEndpoint: "https://ik.imagekit.io/fjhlhw08x",
  authenticationEndpoint: "/api/auth/ik",
});

const ImageKitDirectUpload = ({ value, onChange }: ImageKitDirectUploadProps) => {
  const [ fileLoading, setFileLoading ] = useState(false);

  const uploadPic = (file: RcFile) => {
    setFileLoading(true);
    imagekit.upload({
      file: file,
      fileName: file.name,
      tags: 'logo'
    }, (err, res) => {
      setFileLoading(false);
      if(err) {
        // TODO: Show
      }
      if(onChange) onChange(res!.url);
    });
    return false;
  }


  return <Upload
    multiple={false}
    accept={'image/*'}
    listType="picture-card"
    className={styles.logoUploader}
    beforeUpload={uploadPic}
    showUploadList={false}
  >
    {!!value ? <img src={imagekit.url({
                src: value,
                transformation : [{ height: '128', width: '128'}]
            })} alt="Logo" className={styles.image} /> : <div>
      {fileLoading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Cargar</div>
    </div>}
  </Upload>
};

export default ImageKitDirectUpload;